import { Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { Astrolabe } from "./Astrolabe";
import { Sparkle } from "./Mark";
import { MoonPhase } from "./MoonPhase";
import { CONTACT, CONTACT_EMAIL, mailto } from "../../content";

export const Contact = () => (
  <section id="contact" tabIndex={-1} data-testid="contact-section" className="relative py-28 sm:py-40 overflow-hidden outline-none bg-[#0F161E] border-t border-[#B59A5B]/20">
    <Astrolabe className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] max-w-none text-[#B59A5B]/20 pointer-events-none" />
    <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
      <Reveal>
        <Sparkle className="mx-auto w-5 h-5 text-[#C9AD6A] twinkle" />
        <h2 data-testid="contact-heading" className="mt-8 font-display font-light text-5xl sm:text-7xl lg:text-8xl text-[#FAF6ED] leading-[0.98]">
          Begin a <span className="italic gold-shimmer">Conversation</span>
        </h2>
        <p className="mt-7 font-display italic text-xl sm:text-2xl text-[#FAF6ED]/85">{CONTACT.line}</p>
      </Reveal>
      <Reveal delay={0.15}>
        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-3 font-caps text-[11px] sm:text-xs tracking-[0.25em] uppercase text-[#FAF6ED]/80">
          {CONTACT.invites.map((i, idx) => (
            <li key={i} className="flex items-center gap-6">
              {idx > 0 && <Sparkle className="w-2 h-2 text-[#B59A5B]" />}
              {i}
            </li>
          ))}
        </ul>
        <a href={mailto("Consultation inquiry")} data-testid="contact-mailto-button" className="btn-gold btn-lg group mt-12">
          <Mail className="w-5 h-5" /> Contact Us
        </a>
        <p className="mt-7">
          <a href={mailto()} data-testid="contact-email-link" className="font-display text-xl sm:text-2xl text-[#E2CC92] link-underline break-all">
            {CONTACT_EMAIL}
          </a>
        </p>
        <p className="mt-6 text-sm text-[#FAF6ED]/70 font-body">{CONTACT.note}</p>
        <MoonPhase />
      </Reveal>
    </div>
  </section>
);
